export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/shield.d0616ba7.svg","height":38,"width":32};